<mgd-expandable-form-section [expanded]="expanded">
  <span mgdFormSectionIcon><mat-icon>checklist</mat-icon></span>
  <span mgdFormSectionHeader>{{ heading }}</span>
  <div class="selection-list">
    <mat-list>
      @for (record of records; track $index) {
        <mat-list-item>{{ displayWith(record) }}</mat-list-item>
      }
    </mat-list>
  </div>
</mgd-expandable-form-section>
